import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { TranslocoService } from '@ngneat/transloco';
import { PosManagerMenuService } from 'src/app/components/pos-manager/menu/pos-manager-menu.service';
import { PosManagerConfirmModal } from 'src/app/modals';
import { ModalService } from 'src/app/services';

@Component({
  selector: 'pos-manager-header',
  templateUrl: './manager-header.component.html',
  styleUrls: ['./manager-header.component.scss']
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagerHeaderComponent implements OnInit {
  @Input() color = 'dark';
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hasBackButton = false;
  @Input() hasBackDetailedButton = false;
  @Input() confirmExit = false;
  @Input() confirmExitMessage: string;
  @Input() hasCloseButton = false;
  @Input() backUrl: string;

  constructor(
    private readonly navController: NavController,
    private readonly modalController: ModalController,
    private readonly modalService: ModalService,
    private readonly posManagerMenuService: PosManagerMenuService,
    private readonly route: ActivatedRoute,
    private readonly translocoService: TranslocoService
  ) {}

  ngOnInit(): void {}

  async exit(data = null) {
    const hasBackBtn = this.hasBackButton || this.hasBackDetailedButton;
    const action = () =>
      hasBackBtn
        ? !this.backUrl
          ? this.navController.back()
          : this.navController.navigateBack([this.backUrl], {
              relativeTo: this.route
            })
        : this.modalController.dismiss(data);

    if (this.confirmExit) {
      const message = this.confirmExitMessage ||
        this.translocoService.translate('posManager.confirmExitMessage');

      await this.modalService.showModal(
        PosManagerConfirmModal,
        {
          description: message
        },
        { cssClass: ['small-modal', 'dynamic-height-modal'] },
        ({ data: result }) => result?.deleted && action()
      );
    } else {
      action();
    }
  }

  async openMenu() {
    await this.posManagerMenuService.openMenu();
  }
}
